import "./header.scss";

function Header() {
  return (
    <header className="header">
      <img src="./images/meme-face.png" className="header--image" />
      <h2 className="header--title">Meme Generator</h2>
    </header>
  );
}

export default Header;
